import arrowDownLongSvg from '@fortawesome/fontawesome-free/svgs/solid/arrow-down-long.svg?raw';
import arrowLeftSvg from '@fortawesome/fontawesome-free/svgs/solid/arrow-left.svg?raw';
import arrowRightSvg from '@fortawesome/fontawesome-free/svgs/solid/arrow-right.svg?raw';
import arrowUpLongSvg from '@fortawesome/fontawesome-free/svgs/solid/arrow-up-long.svg?raw';
import arrowsRotateSvg from '@fortawesome/fontawesome-free/svgs/solid/arrows-rotate.svg?raw';
import boltLightningSvg from '@fortawesome/fontawesome-free/svgs/solid/bolt-lightning.svg?raw';
import caretDownSvg from '@fortawesome/fontawesome-free/svgs/solid/caret-down.svg?raw';
import chartPieSvg from '@fortawesome/fontawesome-free/svgs/solid/chart-pie.svg?raw';
import checkSvg from '@fortawesome/fontawesome-free/svgs/solid/check.svg?raw';
import circleCheckSvg from '@fortawesome/fontawesome-free/svgs/solid/circle-check.svg?raw';
import circleExclamationSvg from '@fortawesome/fontawesome-free/svgs/solid/circle-exclamation.svg?raw';
import circleMinusSvg from '@fortawesome/fontawesome-free/svgs/solid/circle-minus.svg?raw';
import circleNotchSvg from '@fortawesome/fontawesome-free/svgs/solid/circle-notch.svg?raw';
import circleXmarkSvg from '@fortawesome/fontawesome-free/svgs/solid/circle-xmark.svg?raw';
import clipboardCheckSvg from '@fortawesome/fontawesome-free/svgs/solid/clipboard-check.svg?raw';
import clockRotateLeftSvg from '@fortawesome/fontawesome-free/svgs/solid/clock-rotate-left.svg?raw';
import codeSvg from '@fortawesome/fontawesome-free/svgs/solid/code.svg?raw';
import copySvg from '@fortawesome/fontawesome-free/svgs/solid/copy.svg?raw';
import desktopSvg from '@fortawesome/fontawesome-free/svgs/solid/desktop.svg?raw';
import exclamationSvg from '@fortawesome/fontawesome-free/svgs/solid/exclamation.svg?raw';
import eyeSvg from '@fortawesome/fontawesome-free/svgs/solid/eye.svg?raw';
import eyeSlashSvg from '@fortawesome/fontawesome-free/svgs/solid/eye-slash.svg?raw';
import fileCircleXmarkSvg from '@fortawesome/fontawesome-free/svgs/solid/file-circle-xmark.svg?raw';
import gearSvg from '@fortawesome/fontawesome-free/svgs/solid/gear.svg?raw';
import ghostSvg from '@fortawesome/fontawesome-free/svgs/solid/ghost.svg?raw';
import imageSvg from '@fortawesome/fontawesome-free/svgs/solid/image.svg?raw';
import linkSvg from '@fortawesome/fontawesome-free/svgs/solid/link.svg?raw';
import magnifyingGlassSvg from '@fortawesome/fontawesome-free/svgs/solid/magnifying-glass.svg?raw';
import magnifyingGlassChartSvg from '@fortawesome/fontawesome-free/svgs/solid/magnifying-glass-chart.svg?raw';
import mobileScreenSvg from '@fortawesome/fontawesome-free/svgs/solid/mobile-screen.svg?raw';
import penFancySvg from '@fortawesome/fontawesome-free/svgs/solid/pen-fancy.svg?raw';
import plusSvg from '@fortawesome/fontawesome-free/svgs/solid/plus.svg?raw';
import robotSvg from '@fortawesome/fontawesome-free/svgs/solid/robot.svg?raw';
import spellCheckSvg from '@fortawesome/fontawesome-free/svgs/solid/spell-check.svg?raw';
import spinnerSvg from '@fortawesome/fontawesome-free/svgs/solid/spinner.svg?raw';
import squareSvg from '@fortawesome/fontawesome-free/svgs/solid/square.svg?raw';
import tabletScreenButtonSvg from '@fortawesome/fontawesome-free/svgs/solid/tablet-screen-button.svg?raw';
import terminalSvg from '@fortawesome/fontawesome-free/svgs/solid/terminal.svg?raw';
import triangleExclamationSvg from '@fortawesome/fontawesome-free/svgs/solid/triangle-exclamation.svg?raw';
import upRightFromSquareSvg from '@fortawesome/fontawesome-free/svgs/solid/up-right-from-square.svg?raw';
import userSvg from '@fortawesome/fontawesome-free/svgs/solid/user.svg?raw';
import wandMagicSparklesSvg from '@fortawesome/fontawesome-free/svgs/solid/wand-magic-sparkles.svg?raw';
import xmarkSvg from '@fortawesome/fontawesome-free/svgs/solid/xmark.svg?raw';
import chevronDownSvg from '@fortawesome/fontawesome-free/svgs/solid/chevron-down.svg?raw';
import chevronRightSvg from '@fortawesome/fontawesome-free/svgs/solid/chevron-right.svg?raw';
import chevronUpSvg from '@fortawesome/fontawesome-free/svgs/solid/chevron-up.svg?raw';

const iconSvgs = {
  'fa-arrow-left': arrowLeftSvg,
  'fa-arrow-right': arrowRightSvg,
  'fa-bolt-lightning': boltLightningSvg,
  'fa-caret-down': caretDownSvg,
  'fa-chart-pie': chartPieSvg,
  'fa-check': checkSvg,
  'fa-check-circle': circleCheckSvg,
  'fa-check-double': clipboardCheckSvg,
  'fa-chevron-down': chevronDownSvg,
  'fa-chevron-right': chevronRightSvg,
  'fa-chevron-up': chevronUpSvg,
  'fa-circle-check': circleCheckSvg,
  'fa-circle-notch': circleNotchSvg,
  'fa-circle-xmark': circleXmarkSvg,
  'fa-clipboard-check': clipboardCheckSvg,
  'fa-clock-rotate-left': clockRotateLeftSvg,
  'fa-close': xmarkSvg,
  'fa-code': codeSvg,
  'fa-copy': copySvg,
  'fa-desktop': desktopSvg,
  'fa-down-long': arrowDownLongSvg,
  'fa-exclamation': exclamationSvg,
  'fa-external-link-alt': upRightFromSquareSvg,
  'fa-eye': eyeSvg,
  'fa-eye-slash': eyeSlashSvg,
  'fa-file-circle-xmark': fileCircleXmarkSvg,
  'fa-gear': gearSvg,
  'fa-ghost': ghostSvg,
  'fa-image': imageSvg,
  'fa-link': linkSvg,
  'fa-magnifying-glass': magnifyingGlassSvg,
  'fa-magnifying-glass-chart': magnifyingGlassChartSvg,
  'fa-minus-circle': circleMinusSvg,
  'fa-mobile-screen': mobileScreenSvg,
  'fa-pen-fancy': penFancySvg,
  'fa-plus': plusSvg,
  'fa-refresh': arrowsRotateSvg,
  'fa-robot': robotSvg,
  'fa-spell-check': spellCheckSvg,
  'fa-spinner': spinnerSvg,
  'fa-square': squareSvg,
  'fa-tablet-screen-button': tabletScreenButtonSvg,
  'fa-terminal': terminalSvg,
  'fa-times': xmarkSvg,
  'fa-trash': xmarkSvg,
  'fa-triangle-exclamation': triangleExclamationSvg,
  'fa-up-long': arrowUpLongSvg,
  'fa-user': userSvg,
  'fa-warning': triangleExclamationSvg,
  'fa-wand-magic-sparkles': wandMagicSparklesSvg,
};

const modifierClasses = new Set(['fa', 'fa-solid', 'fa-regular', 'fa-brands', 'fa-fw', 'fa-spin']);

export function normalizeInlineFaIcon(icon) {
  if (!icon) return null;

  const classes = Array.isArray(icon)
    ? icon.flatMap(value => String(value || '').split(/\s+/))
    : String(icon).split(/\s+/);

  return classes.find(className => className.startsWith('fa-') && !modifierClasses.has(className)) || null;
}

export function getInlineFaIconSvg(icon) {
  const normalizedIcon = normalizeInlineFaIcon(icon);
  return normalizedIcon ? iconSvgs[normalizedIcon] || null : null;
}

export function createInlineFaIconMarkup(icon, extraClass = '') {
  const svg = getInlineFaIconSvg(icon);
  if (!svg) return '';

  return svg.replace('<svg', `<svg class="inline-fa-svg ${extraClass}" aria-hidden="true" focusable="false"`);
}

function isInlineFaTarget(element) {
  return element instanceof HTMLElement
    && ['I', 'SPAN'].includes(element.tagName)
    && (element.classList.contains('fa') || element.classList.contains('fa-solid'));
}

function inlineFaElement(element) {
  if (!isInlineFaTarget(element) || element.dataset.inlineFaProcessed === 'true') {
    return;
  }

  const svgMarkup = createInlineFaIconMarkup(Array.from(element.classList), element.classList.contains('fa-spin') ? 'inline-fa-spin' : '');
  if (!svgMarkup) {
    return;
  }

  element.innerHTML = svgMarkup;
  element.classList.add('inline-fa-icon');
  element.classList.remove('fa', 'fa-solid');
  element.dataset.inlineFaProcessed = 'true';
}

export function inlineFaIconsInElement(root) {
  if (!root) {
    return;
  }

  if (isInlineFaTarget(root)) {
    inlineFaElement(root);
  }

  root.querySelectorAll?.('i.fa, i.fa-solid, span.fa, span.fa-solid').forEach(inlineFaElement);
}

export function observeInlineFaIcons(root) {
  if (!root) {
    return () => {};
  }

  inlineFaIconsInElement(root);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) {
          return;
        }

        inlineFaIconsInElement(node);
      });
    });
  });

  observer.observe(root, { childList: true, subtree: true });

  return () => observer.disconnect();
}
